import HorizontalProgress from '@cp/src/components/ProgressBars/horizontalProgress/HorizontalProgress';
import { Typography } from '@navi/web-ui/lib/primitives';
import styles from './index.module.scss';
import Lottie from 'react-lottie';
import targetAchievedLottie from '../../../../assets/json/target-achieved-lottie.json';
import cx from 'classnames';
import { MAX_PERFORMANCE } from '@cp/src/constants/Global';
import { formatAmount } from '@cp/src/utils/commonUtils';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';

const DrrAcheivedToday = () => {
  const emiCollectedData = useSelector(
    (state: RootState) => state.telePerformanceDashboard.emiCollectedOverview
  );
  const { todayEmiCollected, todayEmiTarget } = emiCollectedData || {};
  const percentage = (todayEmiCollected / todayEmiTarget) * 100;
  const isTargetOverAchieved = percentage >= MAX_PERFORMANCE;

  return (
    <div
      className={cx({
        ['p-3 bg-[var(--bg-secondary)] rounded-lg relative']: true,
        [styles.drrTargetAchieved]: isTargetOverAchieved
      })}
    >
      {isTargetOverAchieved && (
        <div className={styles.targetAchievedAnimation}>
          <Lottie
            options={{
              loop: false,
              autoplay: true,
              animationData: targetAchievedLottie,
              rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
              }
            }}
          />
        </div>
      )}
      <Typography variant="p5" color="var(--grayscale-2)">
        DRR achieved today
      </Typography>
      <div className="flex flex-row items-center justify-between mt-8">
        <Typography variant="h2" color="var(--blue-dark)" className="font-semibold">
          {`${formatAmount(todayEmiCollected)}`}
        </Typography>
        <Typography variant="h4" color="var(--grayscale-2)" className="font-semibold">
          {`${formatAmount(todayEmiTarget)}`}
        </Typography>
      </div>
      <HorizontalProgress
        percentage={percentage}
        toShowPerformanceMeter={true}
        className={cx({
          'h-[14px] bg-[var(--navi-toast-spinner-color-empty-area)] overflow-visible w-full relative':
            true,
          'w-[90%]': isTargetOverAchieved
        })}
        percentageClassName={styles.drrAchievedProgressBar}
        showTooltip={true}
        tooltipContent={
          <div className="flex flex-col gap-1">
            <Typography variant="p4" color="var(--text-primary)">
              {`${percentage.toFixed(0)}% Collected`}
            </Typography>

            <Typography variant="p4" color="var(--text-primary)">
              {percentage < 100
                ? `${formatAmount(todayEmiTarget - todayEmiCollected)} Pending`
                : `${formatAmount(todayEmiCollected - todayEmiTarget)} more than goal`}
            </Typography>
          </div>
        }
      />
    </div>
  );
};

export default DrrAcheivedToday;
